<v-container fluid class="login-container fill-height">
    <v-row justify="center" align="center">
        <v-col cols="12" sm="8" md="4" lg="3">

            <v-card class="login-card elevation-8">
                <v-card-text class="pa-6">

                    <!-- Intestazione comune -->
                    <div class="text-center mb-6 d-flex flex-column align-center">
                        <v-img :src="require('@/assets/logo.png')" width="72" height="75" />
                        <div class="text-h5 font-weight-bold mt-2">Rilievi Misure</div>
                        <div class="text-caption text-medium-emphasis">Reimpostazione password</div>
                    </div>

                    <!-- ── Stato: verifica token in corso ──────────────────── -->
                    <template v-if="stato === 'verifica'">
                        <div class="d-flex flex-column align-center py-4">
                            <v-progress-circular indeterminate color="primary" class="mb-4" />
                            <span class="text-body-2 text-medium-emphasis">Verifica del link in corso…</span>
                        </div>
                    </template>

                    <!-- ── Stato: token non valido o scaduto ───────────────── -->
                    <template v-else-if="stato === 'errore'">
                        <div class="text-center py-2">
                            <v-icon icon="mdi-link-off" color="error" size="48" class="mb-3" />
                            <div class="text-body-1 font-weight-medium mb-1">Link non valido</div>
                            <div class="text-body-2 text-medium-emphasis mb-5">
                                Il link di reset è scaduto o è già stato utilizzato.
                                Richiedine uno nuovo dalla pagina di accesso.
                            </div>
                            <v-btn color="primary" variant="elevated" block @click="vaiAlLogin">
                                Torna al login
                            </v-btn>
                        </div>
                    </template>

                    <!-- ── Stato: form nuova password ──────────────────────── -->
                    <template v-else-if="stato === 'form'">
                        <v-form ref="formReset" @submit.prevent="submit">

                            <v-text-field v-model="password" label="Nuova password" prepend-inner-icon="mdi-lock"
                                variant="outlined" density="comfortable" :type="mostraPassword ? 'text' : 'password'"
                                :append-inner-icon="mostraPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                @click:append-inner="mostraPassword = !mostraPassword" :rules="regolePassword" />

                            <v-text-field v-model="confermaPassword" label="Conferma password"
                                prepend-inner-icon="mdi-lock-check" variant="outlined" density="comfortable"
                                :type="mostraConferma ? 'text' : 'password'"
                                :append-inner-icon="mostraConferma ? 'mdi-eye-off' : 'mdi-eye'"
                                @click:append-inner="mostraConferma = !mostraConferma" :rules="regoleConferma" />

                            <!-- Requisiti password -->
                            <div class="mb-4">
                                <div v-for="req in requisitiPassword" :key="req.testo"
                                    class="d-flex align-center text-caption mb-1">
                                    <v-icon :icon="req.soddisfatto ? 'mdi-check-circle' : 'mdi-circle-outline'"
                                        :color="req.soddisfatto ? 'success' : 'grey'" size="14" class="mr-1" />
                                    <span :class="req.soddisfatto ? 'text-success' : 'text-medium-emphasis'">
                                        {{ req.testo }}
                                    </span>
                                </div>
                            </div>

                            <v-btn block size="large" color="primary" type="submit" :loading="attesa"
                                :disabled="attesa">
                                Reimposta password
                            </v-btn>

                        </v-form>
                    </template>

                    <!-- ── Stato: successo ─────────────────────────────────── -->
                    <template v-else-if="stato === 'successo'">
                        <div class="text-center py-2">
                            <v-icon icon="mdi-check-circle" color="success" size="48" class="mb-3" />
                            <div class="text-body-1 font-weight-medium mb-1">Password aggiornata</div>
                            <div class="text-body-2 text-medium-emphasis mb-5">
                                La tua password è stata reimpostata con successo.
                                Puoi ora accedere con le nuove credenziali.
                            </div>
                            <v-btn color="primary" variant="elevated" block @click="vaiAlLogin">
                                Vai al login
                            </v-btn>
                        </div>
                    </template>

                </v-card-text>
            </v-card>

            <div class="text-center text-caption mt-4 text-medium-emphasis">
                Sistema gestione rilievi
            </div>

        </v-col>
    </v-row>
</v-container>